import { Flex } from '../../../../layout/Flex';
import { StatisticItemSkeleton } from './styles';

export const StatisticSkeleton = () => (
    <Flex
        width="100%"
        direction="row"
        alignItems="stretch"
        justifyContent="stretch"
        flexWrap={{ xs: 'wrap', sm: 'nowrap' }}
    >
        <StatisticItemSkeleton mr={1} />
        <StatisticItemSkeleton mr={{ xs: 0, sm: 1 }} />
        <StatisticItemSkeleton mr={1} mt={{ xs: 1, sm: 0 }} />
        <StatisticItemSkeleton mt={{ xs: 1, sm: 0 }} />
    </Flex>
);
